(() => {
  'use strict';
  const pending = new Map();
  let active = 0;
  const waiting = [];
  async function slot(fn) {
    if (active >= 5) await new Promise(resolve => waiting.push(resolve));
    active++;
    try { return await fn(); } finally { active--; waiting.shift()?.(); }
  }
  async function json(url,signal) {
    const response = await fetch(url,{signal,credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
    if (!response.ok) throw Error('Shopify search unavailable');
    return response.json();
  }
  function plain(html) {
    return new DOMParser().parseFromString(String(html || ''),'text/html').body.textContent || '';
  }
  function product(raw,root) {
    if (!raw || !Array.isArray(raw.variants) || !Array.isArray(raw.options)) throw Error('Incomplete product data');
    return {...raw,description:plain(raw.description),url:root+'products/'+encodeURIComponent(raw.handle),image:raw.featured_image || raw.images?.[0] || null,
      options:raw.options.map(option => typeof option === 'string' ? option : option.name),
      variants:raw.variants.map(v=>({...v,options:v.options || [v.option1,v.option2,v.option3].filter(x=>x!==null&&x!==undefined),image:v.featured_image?.src || null}))};
  }
  async function load(handle,signal,root) {
    if (!/^[a-z0-9][a-z0-9-]*$/i.test(handle || '')) throw Error('Invalid product handle');
    const key=root+handle;
    if (pending.get(key)?.signal?.aborted) pending.delete(key);
    if (!pending.has(key)) {
      const promise=slot(async()=>{if(signal?.aborted)throw new DOMException('Aborted','AbortError');return product(await json(root+'products/'+encodeURIComponent(handle)+'.js',signal),root);});
      pending.set(key,{promise,signal});
      promise.finally(()=>{if(pending.get(key)?.promise===promise)pending.delete(key);}).catch(()=>{});
    }
    return pending.get(key).promise;
  }
  async function search(q,signal) {
    const ctx=await window.StepUpFinderContextReady;
    if (!ctx || typeof ctx.taxesIncluded!=='boolean') throw Error('Tax context unavailable');
    const url=new URL(ctx.root+'search/suggest.json',new URL(document.baseURI).origin);
    url.search=new URLSearchParams({q,'resources[type]':'product','resources[limit]':'10','resources[options][unavailable_products]':'last'});
    const response=await json(url,signal);
    const found=response.resources?.results?.products;
    if (!Array.isArray(found)) throw Error('Invalid Shopify response');
    const values=await Promise.allSettled(found.map(p=>load(p.handle,signal,ctx.root)));
    if (signal?.aborted) throw new DOMException('Aborted','AbortError');
    const products=values.filter(x=>x.status==='fulfilled').map(x=>x.value);
    if (found.length && !products.length) throw Error('Product details unavailable');
    return {schemaVersion:2,meta:{currency:ctx.currency,country:ctx.country,taxesIncluded:ctx.taxesIncluded},total:found.length,pages:1,page:1,products};
  }
  const api=Object.freeze({search,product});
  if(typeof module==='object'&&module.exports)module.exports=api;
  if(typeof window!=='undefined')window.StepUpLiveCatalogue=api;
})();

(() => {
  'use strict';
  const normal = s => String(s || '').toLowerCase().replace(/[’']/g, '').replace(/\bhi[ -]?vis(?:ibility)?\b/g,'hivis').replace(/\bt[ -]?shirts?\b/g,'tee').replace(/\bl\/s\b/g,'long sleeve').replace(/\bs\/s\b/g,'short sleeve').replace(/[^a-z0-9]+/g,' ').trim();
  const words = s => normal(s).split(' ').filter(Boolean);
  const near = (a,b) => { if(a===b)return true;if(a.length<4||b.length<4||Math.abs(a.length-b.length)>1||/\d/.test(a+b))return false;let x=0,y=0,edits=0;while(x<a.length&&y<b.length){if(a[x]===b[y]){x++;y++;continue;}if(++edits>1)return false;if(a.length>=b.length)x++;if(b.length>=a.length)y++;}return edits+(a.length-x)+(b.length-y)<=1; };
  const contains = (s,w) => (' '+normal(s)+' ').includes(' '+normal(w)+' ');
  const types = [['polo',/\bpolos?\b/],['tee',/\b(?:tees?|t[ -]?shirts?)\b/],['hoodie',/\bhood(?:ies?|ed)\b/],['shirt',/\bshirts?\b/],['jacket',/\bjackets?\b/],['shorts',/\bshorts\b/],['pants',/\b(?:pants|trousers)\b/],['cap',/\b(?:caps?|hats?|headwear)\b/]];
  function kind(text) { const s=normal(text); return types.find(([,r])=>r.test(s))?.[0] || ''; }
  const rules = [
    ['hi-vis',/\bhivis\b/,/\b(?:hivis|high visibility)\b/],
    ['long sleeve',/\blong sleeves?\b/,/\b(?:long sleeve|long sleeves)\b/],
    ['short sleeve',/\bshort sleeves?\b/,/\b(?:short sleeve|short sleeves)\b/],
    ['lightweight',/\b(?:lightweight|light weight)\b/,/\b(?:lightweight|light weight)\b/],
    ['heavyweight',/\b(?:heavyweight|heavy weight)\b/,/\b(?:heavyweight|heavy weight)\b/],
    ['cotton',/\bcotton\b/,/\bcotton\b/],['polyester',/\bpolyester\b/,/\bpolyester\b/],
    ['ripstop',/\bripstop\b/,/\bripstop\b/],['stretch',/\bstretch\b/,/\bstretch\b/],
    ['waterproof',/\bwaterproof\b/,/\bwaterproof\b/],['reflective',/\breflective\b/,/\breflective\b/],
    ['UPF 50+',/\b(?:upf 50|uv protection|sun protection)\b/,/\bupf (?:protection )?50\b/],
    ['flame resistant',/\b(?:flame resistant|fire resistant|fr)\b/,/\b(?:flame resistant|fire resistant)\b/],
    ['arc rated',/\b(?:arc rated|arc flash)\b/,/\b(?:arc rated|arc flash)\b/],
    ['moisture wicking',/\b(?:wicking|moisture wicking)\b/,/\bwicking\b/],
    ['breathable',/\bbreathable\b/,/\bbreathable\b/],['womens',/\b(?:womens|women|ladies|female)\b/,/\b(?:womens|women|ladies|female)\b/],
    ['mens',/\b(?:mens|men|male)\b/,/\b(?:mens|men|male|unisex)\b/]
  ];
  const palette=['orange','black','yellow','lime','navy','white','blue','red','green','grey','charcoal','pink','purple','ecru','sand','brown'];
  const stop=new Set('a an the with and or for our my us company logo crew team plumbing plumber plumbers work workwear ideal want need looking lightweight heavyweight light heavy weight colour color cotton polyester sleeves sleeve long short hi vis hivis shirt shirts polo polos tee tees hoodies hoodie jacket jackets pants trousers cap caps hat hats t black orange yellow lime navy white blue red green grey charcoal pink purple ecru sand brown of in on to some please would like branded custom uniform uniforms printing embroidery embroidered print'.split(' '));
  function intent(q) {
    const n=normal(q), type=kind(q), colors=palette.filter(c=>contains(n,c));
    const requirements=rules.filter(([,r])=>r.test(n));
    const weight=n.match(/\b(\d{2,3})\s*(?:gsm|g m2|g m)\b/);
    const tokens=words(q).filter(w=>!stop.has(w)&&!/^\d+$/.test(w)&&!['gsm','g','m2','upf'].includes(w));
    const code=/^\d{3,}$/.test(n)?n:words(q).find(w=>/\d/.test(w)&&/[a-z]/.test(w)&&!/^\d+gsm$/.test(w));
    const negative=/\b(?:no|not|without|except|exclude)\b/.test(n);
    return {q,n,type,colors,requirements,weight:weight?Number(weight[1]):null,tokens,code,negative};
  }
  function scoreProduct(p,i) {
    const title=normal(p.title), text=normal(p.title+' '+p.description), tokens=words(p.title+' '+p.vendor+' '+p.description);
    if (/\b(?:decoration|digitising|digitizing|transfer fee|shipping)\b/.test(title) && !kind(title)) return null;
    const skuMatch=p.variants.find(v=>normal(v.sku)===i.n);
    const style=(p.description||'').match(/(?:style reference|product code|style code)[:\s]+([\w-]+)/i)?.[1];
    const exact=!!skuMatch || title===i.n || (!!i.code && (normal(style)===normal(i.code)||p.variants.some(v=>words(v.sku).includes(i.code))));
    const titleHit=i.tokens.length>0 && i.tokens.every(t=>words(title).some(w=>near(t,w))); 
    const vendorHit=i.tokens.length>0 && i.tokens.every(t=>words(p.vendor).some(w=>near(t,w)));
    let missing=[],features=[],score=exact?10000:titleHit?300:vendorHit?200:0;
    const actual=kind(p.title)||kind(p.type);
    if(i.type && actual!==i.type) missing.push(i.type+' (listed as '+(actual||'unconfirmed garment type')+')');
    if(i.negative) missing.push('exclusion requirements need review');
    for(const [label,,test] of i.requirements) {
      const gsm=Number(text.match(/\b(\d{2,3})\s*(?:gsm|g m|g m2)\b/)?.[1]);
      const affirmative=text.replace(/\b(?:not|no|non) (?:\w+ )?(?:waterproof|reflective|breathable|flame resistant|fire resistant|arc rated)\b/g,'');
      let valid=test.test(affirmative);
      if(label==='heavyweight' && gsm>=220 && ['tee','polo','shirt'].includes(actual)) valid=true;
      if(label==='lightweight' && gsm>0 && gsm<=170 && ['tee','polo','shirt'].includes(actual)) valid=true;
      if(valid) {features.push((label==='lightweight'||label==='heavyweight')&&gsm?label+' · '+gsm+' gsm':label);score+=20;} else missing.push(label+' not confirmed');
    }
    if(i.weight && !new RegExp('\\b'+i.weight+'\\s*(?:gsm|g m)').test(text)) missing.push(i.weight+' gsm not confirmed');
    const colorIndex=p.options.findIndex(n=>/colou?r/i.test(n));
    const fullColor=v=>i.colors.every(c=>contains(colorIndex>=0?v.options[colorIndex]:'',c));
    let vs=p.variants.filter(fullColor);
    if(i.colors.length && !vs.length) {missing.push(i.colors.join('/')+' colour combination unavailable');vs=p.variants;}
    const v=skuMatch || vs.find(v=>v.available&&v.image) || vs.find(v=>v.available) || vs[0];
    if(!v) return null;
    if(i.colors.length && fullColor(v)) {score+=40;if(v.image)score+=5;if(normal(v.options[colorIndex])===i.colors.join(' '))score+=15;}
    const requirementWords=new Set(i.requirements.flatMap(r=>words(r[0])));
    const residual=i.tokens.filter(t=>!tokens.some(w=>near(t,w))&&!requirementWords.has(t));
    if(!exact && !titleHit && residual.length) return null;
    if(i.code && !exact) return null;
    if(!i.type&&!i.colors.length&&!i.requirements.length&&!titleHit&&!vendorHit&&!exact) return null;
    if(!v.available) {if(!exact) return null;missing.push('currently unavailable');}
    score+=i.tokens.filter(t=>tokens.includes(t)).length*15;
    if(p.vendor==='Step Up Workwear') score-=15;
    return {p,v,score,exact,missing,features,color:colorIndex>=0?v.options[colorIndex]:''};
  }
  function displayPrice(variant,meta) {
    const cents=Number(variant.price);
    if(!Number.isSafeInteger(cents)||cents<0)return {cents:null,key:'price_unknown'};
    if(cents===0)return {cents:null,key:'price_zero'};
    if(meta?.currency==='AUD'&&meta?.country==='AU') {
      if(meta.taxesIncluded===false)return {cents,key:'price'};
      if(meta.taxesIncluded===true&&variant.taxable===true)return {cents:Math.round(cents*10/11),key:'price',gross:cents};
      if(meta.taxesIncluded===true&&variant.taxable===false)return {cents,key:'price',gstFree:true};
      return {cents:null,key:'price_unknown',unknown:true};
    }
    if(typeof meta?.taxesIncluded==='boolean'&&/^[A-Z]{3}$/.test(meta?.currency||''))return {cents,key:meta.taxesIncluded?'price_tax_included':'price_tax_excluded'};
    return {cents:null,key:'price_unknown',unknown:true};
  }
  function selectMatches(products,q) {
    const i=intent(q);
    const scored=products.map(p=>scoreProduct(p,i)).filter(Boolean).sort((a,b)=>b.score-a.score);
    const strict=scored.filter(x=>!x.missing.length||x.exact);
    return {items:strict.length?strict:scored.filter(x=>x.missing.length<=2).slice(0,9),alternatives:!strict.length};
  }
  function normaliseProducts(products) {
    return products.filter(p=>Array.isArray(p.variants)&&Array.isArray(p.options)).map(p=>({...p,variants:p.variants.map(v=>({...v,image:v.featured_image?.src||v.image||null}))}));
  }
  function safeProductUrl(path,origin,variantId) {
    try {const u=new URL(path,origin);if(u.origin!==origin||!u.pathname.includes('/products/'))return null;
      u.search='';u.searchParams.set('variant',variantId);u.searchParams.set('su_finder','1');return u;
    } catch {return null;}
  }
  function handoff(scope=document) {
    const params=new URLSearchParams(location.search);
    if(params.get('su_finder')!=='1'||!params.get('variant'))return;
    scope.querySelectorAll('[data-su-builder][data-supported="true"]').forEach(box=>{
      if(box.dataset.suFinderHandoff)return;
      try {
        const product=JSON.parse(box.querySelector('[data-su-product]').textContent);
        const variant=product.variants.find(v=>String(v.id)===params.get('variant'));
        const index=product.options.findIndex(o=>/colou?r/i.test(typeof o==='string'?o:o.name));
        const select=box.querySelector('[data-su-colour]');
        if(!variant||index<0||!select||select.value||!Array.from(select.options).some(o=>o.value===variant.options[index]))return;
        if(Array.from(box.querySelectorAll('input[type="number"]')).some(e=>Number(e.value)>0))return;
        select.value=variant.options[index];select.dispatchEvent(new Event('change',{bubbles:true}));box.dataset.suFinderHandoff='true';
      } catch {}
    });
  }
  function initialize(scope=document) {
    scope.querySelectorAll('[data-su-finder]').forEach(root=>{
      if(root.dataset.suFinderReady)return;
      root.dataset.suFinderReady='true';
      const strings=JSON.parse(root.querySelector('[data-su-strings]').textContent), form=root.matches('form')?root:root.querySelector('form'),input=form.querySelector('input[name="q"]'),panel=root.querySelector('.su-finder__panel'),status=root.querySelector('[data-su-status]'),results=root.querySelector('[data-su-results]'),more=root.querySelector('[data-su-more]'),fallback=root.querySelector('[data-su-fallback]');
      const storeOrigin=new URL(document.baseURI).origin, endpoint=root.dataset.search;
      let controller,generation=0,ranked=[],shown=3,lastQuery='',meta;
      const tx=(key,values={})=>Object.entries(values).reduce((s,[k,v])=>s.replaceAll('{{ '+k+' }}',String(v)),strings[key]||key);
      const text=(tag,value,cls)=>{const el=document.createElement(tag);el.textContent=value;if(cls)el.className=cls;return el;};
      const money=(cents)=>new Intl.NumberFormat('en-AU',{style:'currency',currency:meta.currency}).format(cents/100);
      function searchUrl(q,view,page=1){const u=new URL(endpoint,storeOrigin);u.search=new URLSearchParams({q,type:'product','options[prefix]':'last','options[unavailable_products]':'last',...(view?{view:'stepup-finder',page}:{})});return u;}
      async function page(q,signal,n=1){return window.StepUpLiveCatalogue.search(q,signal);}
      function render(){
        results.replaceChildren();
        for(const item of ranked.slice(0,shown)){
          const {p,v,color,features,missing}=item,u=safeProductUrl(p.url,storeOrigin,v.id);if(!u)continue;
          const card=text('article','','su-finder__card');
          const src=v.image||p.image;
          if(src){try{const imgUrl=new URL(src,storeOrigin);if(['https:','http:','data:'].includes(imgUrl.protocol)){const img=document.createElement('img');img.src=imgUrl.href;img.alt=p.title+(v.image&&color?' — '+color:'');img.loading='lazy';img.width=300;img.height=200;card.append(img);}}catch{}}
          card.append(text('p',p.vendor,'su-finder__brand'),text('h3',p.title));
          if(missing.length)card.append(text('p',tx('alternatives'),'su-finder__badge'));
          const price=displayPrice(v,meta);
          card.append(text('p',price.cents===null?tx(price.key):money(price.cents)+' '+tx(price.key),'su-finder__price'));
          if(price.gross)card.append(text('p',tx('original_price',{amount:money(price.gross)}),'su-finder__tax'));
          if(price.gstFree)card.append(text('p',tx('gst_free'),'su-finder__tax'));
          if(price.unknown)card.append(text('p',tx('tax_unknown'),'su-finder__tax'));
          card.append(text('p',/included/i.test(p.title)?tx('included'):tx('garment')));
          if(color){card.append(text('p',color,'su-finder__swatch'));card.append(text('p','Select this colour on the product page.','su-finder__tax'));}
          if(!v.image&&p.image&&color)card.append(text('p',tx('default_image'),'su-finder__tax'));
          if(features.length)card.append(text('p',features.join(' · ')));
          const reason=item.exact?tx('exact_reason'):missing.length?tx('alternative_reason'):tx('match_reason',{details:[kind(p.title)||kind(p.type),color,...features].filter(Boolean).slice(0,4).join(' · ')});
          card.append(text('p',reason,'su-finder__reason'));
          if(missing.length)card.append(text('p',missing.join('; '),'su-finder__missing'));
          const link=text('a',tx('view'),'su-finder__cta');link.href=u.href;link.target='_top';link.setAttribute('aria-label',tx('view')+' — '+p.title+(color?' — '+color:''));card.append(link);results.append(card);
        }
        if(!ranked.length)results.append(text('p',tx('empty'),'su-finder__empty'));
        more.hidden=shown>=ranked.length;
      }
      async function search(){
        const q=input.value.trim().slice(0,240),run=++generation;controller?.abort();
        if(q.length<2){panel.hidden=true;return;}
        lastQuery=q;shown=3;const localController=new AbortController();controller=localController;
        panel.hidden=false;results.replaceChildren();status.textContent=tx('loading');results.setAttribute('aria-busy','true');more.hidden=true;fallback.href=searchUrl(q,false);fallback.target='_top';
        const timeout=setTimeout(()=>localController.abort(),15000);
        try{
          const i=intent(q),queries=[q],clean=[...i.colors,...(i.requirements.some(r=>r[0]==='hi-vis')?['hi vis']:[]),i.type==='tee'?'tee':i.type].filter(Boolean).join(' ');
          if(clean&&normal(clean)!==i.n)queries.push(clean);if(i.code&&i.n!==i.code)queries.push(i.code);
          const garment=i.type==='tee'?'tee':i.type;
          if(garment&&i.colors.length)queries.push([garment,...i.colors].join(' '));
          if(garment&&i.requirements.some(r=>r[0]==='hi-vis'))queries.push('hi vis '+garment);
          if(garment)queries.push(garment);
          const selectedQueries=[...new Set(queries)].slice(0,6);
          const data=await Promise.all(selectedQueries.map(x=>page(x,localController.signal)));
          let candidates=data.flatMap(d=>d.products),firstMeta=data[0].meta;
          if(data.some(d=>JSON.stringify(d.meta)!==JSON.stringify(firstMeta)))throw Error('Price context changed');
          const cleanIndex=selectedQueries.indexOf(clean);
          if(cleanIndex>=0&&data[cleanIndex].pages>1){
            const extras=await Promise.all(Array.from({length:Math.min(data[cleanIndex].pages-1,2)},(_,j)=>page(clean,localController.signal,j+2)));
            if(extras.some(d=>JSON.stringify(d.meta)!==JSON.stringify(firstMeta)))throw Error('Price context changed');
            candidates.push(...extras.flatMap(d=>d.products));
          }
          if(run!==generation)return;
          meta=firstMeta;
          const selected=selectMatches([...new Map(candidates.map(p=>[p.id,p])).values()],q);ranked=selected.items;
          status.textContent=ranked.length?tx(selected.alternatives?'alternatives':'matches'):tx('empty');render();
        }catch(e){if(run!==generation)return;status.textContent=tx('failure');results.replaceChildren();more.hidden=true;}
        finally{clearTimeout(timeout);if(run===generation)results.removeAttribute('aria-busy');}
      }
      form.addEventListener('submit',e=>{e.preventDefault();root.dataset.submittedQuery=String(input.value);search().catch(error=>{root.dataset.startError=error.message;panel.hidden=false;status.textContent=tx('failure');});});
      input.addEventListener('input',()=>{generation++;controller?.abort();panel.hidden=true;lastQuery='';});
      input.addEventListener('focus',()=>{if(input.value.trim()===lastQuery&&lastQuery)panel.hidden=false;});
      root.addEventListener('keydown',e=>{if(e.key==='Escape'){input.focus();panel.hidden=true;}if(['ArrowDown','ArrowUp'].includes(e.key)){const links=[input,...results.querySelectorAll('a')],at=links.indexOf(document.activeElement);if(at>=0){e.preventDefault();links[(at+(e.key==='ArrowDown'?1:links.length-1))%links.length].focus();}}});
      root.querySelector('[data-su-close]').addEventListener('click',()=>{input.focus();panel.hidden=true;});
      document.addEventListener('pointerdown',e=>{if(!root.contains(e.target))panel.hidden=true;});
      more.addEventListener('click',()=>{shown+=6;render();});
    });
  }
  const api=Object.freeze({displayPrice,selectMatches,normaliseProducts,safeProductUrl,handoff,initialize});
  if(typeof module==='object'&&module.exports)module.exports=api;
  if(typeof document==='undefined')return;
  if(window.StepUpFinderV2)return;
  window.StepUpFinderV2=api;
  initialize();
  if(document.readyState==='complete')handoff();else window.addEventListener('load',()=>handoff(),{once:true});
  document.addEventListener('shopify:section:load',e=>{initialize(e.target);handoff(e.target);});
})();
(() => {
  'use strict';
  if(window.StepUpHeaderFinder)return;
  let counter=0;
  function enhance(scope=document){
    if(!window.StepUpFinderV2||!window.StepUpLiveCatalogue)return;
    scope.querySelectorAll('[data-su-header-finder-raw]').forEach(original=>{
      if(original.dataset.suHeaderReady)return;
      try{
        const context=JSON.parse(original.querySelector('[data-su-context]').textContent);
        JSON.parse(original.querySelector('[data-su-strings]').textContent);
        if(typeof context.taxesIncluded!=='boolean'||!context.root||!context.currency)return;
        const oldInput=original.querySelector('input[name="q"]');
        const focused=document.activeElement===oldInput;
        const currentValue=oldInput.value;
        const form=original.cloneNode(true),input=form.querySelector('input[name="q"]');
        form.querySelectorAll('.predictive-search-wrapper').forEach(node=>node.remove());
        form.classList.remove('is-expanded');
        form.dataset.suHeaderReady='true';form.setAttribute('data-su-finder','');
        form.dataset.root=context.root;form.dataset.search=context.search;
        for(const name of ['focusin','focusout','keydown','input','submit'])form.addEventListener(name,event=>event.stopPropagation());
        input.type='search';input.value=currentValue;input.id='su-header-query-'+(++counter);
        for(const name of ['role','aria-autocomplete','aria-expanded','aria-haspopup','aria-activedescendant'])input.removeAttribute(name);
        form.querySelector('label').htmlFor=input.id;
        const results=form.querySelector('[data-su-results]');results.id=input.id+'-results';input.setAttribute('aria-controls',results.id);
        const help=form.querySelector('[data-su-help]');help.id=input.id+'-help';input.setAttribute('aria-describedby',help.id);
        window.StepUpFinderContextReady=Promise.resolve(context);
        original.replaceWith(form);
        form.closest('[data-search-form-container]')?.setAttribute('data-su-header-shell','');
        window.StepUpFinderV2.initialize();
        form.querySelectorAll('[data-su-example]').forEach(button=>button.addEventListener('click',()=>{
          input.value=button.dataset.suExample;
          input.dispatchEvent(new Event('input',{bubbles:true}));
          input.focus();
        }));
        if(focused)input.focus();
      }catch{}
    });
  }
  window.StepUpHeaderFinder=Object.freeze({enhance});
  if(document.readyState==='complete')enhance();else window.addEventListener('load',()=>enhance(),{once:true});
  document.addEventListener('shopify:section:load',event=>setTimeout(()=>enhance(event.target),0));
})();
